module.exports = __webpack_public_path__ + "img/q5-opt-a.b6207bbc.png";